import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import ProtectedRoute from 'pages/ProtectedRoute/ProtectedRoute';
import Auth from 'utils/Auth';
import { createPath, ROUTE } from 'utils/Routing';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Container from './components/Container/Container';
import HomePage from './pages/HomePage/HomePage';
import GamePage from './pages/GamePage/GamePage';
import GameListPage from './pages/GameListPage/GameListPage';
import Login from './pages/Login/Login';
import Logout from './pages/Logout/Logout';

const App = () => {
  const isAuth = Auth();
  return (
    <>
      <Header isAuth={isAuth} />
      <Container>
        <Switch>
          <Route path={ROUTE.GAME_LIST}>
            <GameListPage />
          </Route>
          <ProtectedRoute isAuth={isAuth} path={ROUTE.GAME_PAGE} component={GamePage} />
          <ProtectedRoute isAuth={isAuth} path={ROUTE.LOGOUT} component={Logout} />
          <Route path={ROUTE.LOGIN}>
            <Login />
          </Route>
          <Route path={ROUTE.HOME} exact>
            <HomePage />
          </Route>
          <Route path={ROUTE.ERROR}>
            <Redirect to={createPath({ path: ROUTE.HOME })} />
          </Route>
        </Switch>
      </Container>
      <Footer />
    </>
  );
};

export default App;
